import React from 'react';
import ReactMarkdown from 'react-markdown';
import githubFlavoredMarkdown from 'remark-gfm';
import styled from '@emotion/styled';
import { MarkdownRenderContext } from './RenderContext';
import { IMarkdownRenderers } from './IMarkdownRenderers';

interface IProps {
	source: string;
}

export function Markdown({ source }: IProps) {
	return (
		<MarkdownRenderContext.Consumer>
			{(renderers: IMarkdownRenderers) => (
				<StyledMarkdownContainer>
					<ReactMarkdown
						plugins={[githubFlavoredMarkdown]}
						components={renderers}
					>
						{source}
					</ReactMarkdown>
				</StyledMarkdownContainer>
			)}
		</MarkdownRenderContext.Consumer>
	);
}

// ul reset is necessary for when markdown content is displayed in a list (e.g. CardSection)
const StyledMarkdownContainer = styled.div`
	p {
		white-space: pre-wrap;
	}
	ul {
		list-style-type: disc;
	}
	ul ul {
		list-style-type: circle;
	}
	ul ul ul {
		list-style-type: square;
	}
`;
